module.exports = __webpack_public_path__ + "img/text_interactive-story-puzzle_white.97ed4948.png";